var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[(_vm.isError)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.errorMessage))]),_c('a',{attrs:{"href":"/"}},[_vm._v("Go Home")])]):_c('h1',[_vm._v("Validating...")])])}
var staticRenderFns = []

export { render, staticRenderFns }